import React from "react";

const Footer = () => {
    return (
        <footer className="bg-custom-green text-white py-9">
            <div className="container mx-auto text-center">
                <p className="text-sm mb-4">&copy; {new Date().getFullYear()} imroatussholikhahnf.All right reserved</p>
            </div>
        </footer>
    )
}

export default Footer;